import React, { useEffect, useState } from 'react';
import './CalcAProofDtResult.css';

import { CalcAProofResult } from '../parts/CalcAProofData';

type Props = {
    calcResult: CalcAProofResult
  }
  
export const CalcAProofDtResult: React.FC<Props> = ({calcResult}) => {

    return (
        <div className="CalcAProofDtResult_content CalcAProofDtResult_table">
            <table>
                <thead>
                </thead>
                <tbody>
                    <tr>
                        <th>
                            Result
                        </th>
                        <td className='CalcAProofDtResult_cell_unit CalcAProofDtResult_cell_top'>unit</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td className='CalcAProofDtResult_cell_top'>Normal</td> */}
                        <td className='CalcAProofDtResult_cell_hidden'>Normal</td>
                        <td className='CalcAProofDtResult_cell_top'>Before</td>
                        <td className='CalcAProofDtResult_cell_top'>After</td>
                        <td className='CalcAProofDtResult_cell_outer'></td>
                    </tr>
                    <tr>
                        <th>
                            NaOH Production
                        </th>
                        <td className='CalcAProofDtResult_cell_unit'>MT/D</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td className='CalcAProofDtResult_cell_top'> */}
                        {/* <td>
                            {
                                calcResult.result?.resultList?.at(0)?.naohProduction?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td> */}
                        <td>
                            {
                                calcResult.result?.resultList?.at(1)?.naohProduction?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                        <td>
                            {
                                calcResult.result?.resultList?.at(2)?.naohProduction?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'></td>
                    </tr>
                    <tr>
                        <th className="CalcAProofDtResult_cell_hidden">
                            Cl2 Production
                        </th>
                        <td className="CalcAProofDtResult_cell_unit CalcAProofDtResult_cell_hidden">MT/D</td>
                        <td className="CalcAProofDtResult_cell_hidden">
                            {
                                calcResult.result?.resultList?.at(0)?.cl2Production?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                        <td className="CalcAProofDtResult_cell_hidden">
                            {
                                calcResult.result?.resultList?.at(1)?.cl2Production?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                        <td className="CalcAProofDtResult_cell_hidden">
                            {
                                calcResult.result?.resultList?.at(2)?.cl2Production?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 1,
                                            maximumFractionDigits: 1
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'></td>
                    </tr>
                    <tr>
                        <th>
                            Estimated NaCl in 50% NaOH
                        </th>
                        <td className="CalcAProofDtResult_cell_unit">ppm</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td>
                            {
                                calcResult.result?.resultList?.at(0)?.naclInNaoh50?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td> */}
                        <td>
                            {
                                calcResult.result?.resultList?.at(1)?.naclInNaoh50?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td>
                            {
                                calcResult.result?.resultList?.at(2)?.naclInNaoh50?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'></td>
                    </tr>
                    <tr>
                        <th>
                            Estimated NaCl in 32% NaOH
                        </th>
                        <td className="CalcAProofDtResult_cell_unit ">ppm</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td>
                            {
                                calcResult.result?.resultList?.at(0)?.naclInNaoh32?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td> */}
                        <td>
                            {
                                calcResult.result?.resultList?.at(1)?.naclInNaoh32?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td>
                            {
                                calcResult.result?.resultList?.at(2)?.naclInNaoh32?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'></td>
                    </tr>
                    <tr>
                        <th>
                            Power
                        </th>
                        <td className="CalcAProofDtResult_cell_unit">kWh/D</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td>
                            {
                                calcResult.result?.resultList?.at(0)?.power?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td> */}
                        <td>
                            {
                                calcResult.result?.resultList?.at(1)?.power?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td>
                            {
                                calcResult.result?.resultList?.at(2)?.power?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'></td>
                    </tr>
                    <tr>
                        <th rowSpan={2}>
                            Improvement
                        </th>
                        <td rowSpan={2} className="CalcAProofDtResult_cell_unit">kWh/D</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td rowSpan={2} colSpan={2}></td> */}
                        <td rowSpan={2} colSpan={1}>-</td>
                        {/* Normal計算式検討中のため非表示 */}
                        {/* <td className='CalcAProofDtResult_cell_improvement'>
                            {
                                calcResult.result?.improvementList?.at(0)?.improvement?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'>vs. Normal (uniform current)</td> */}
                    </tr>
                    <tr>
                        <td className='CalcAProofDtResult_cell_improvement'>
                            {
                                calcResult.result?.improvementList?.at(1)?.improvement?.toLocaleString(
                                    undefined,
                                    {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                    }
                                )
                            }
                        </td>
                        <td className='CalcAProofDtResult_cell_outer'>vs. Before</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
